<template>
  <v-stepper editable v-model="e6" vertical>
    <v-stepper-step editable step="1">
      Websites
      <small>Help Pages about Website</small>
    </v-stepper-step>

    <v-stepper-content step="1">
      <v-card class="mb-5">
        <v-layout row wrap>
          <v-layout v-for="web in websites" :key="web.name">
            <v-flex pa-2 ma-2>
              <a :href="web.link" target="_blank">{{ web.name }}</a>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card>
    </v-stepper-content>

    <v-stepper-step editable step="2">Ecommerce</v-stepper-step>
    <small>Help Pages about Ecommerce </small>
    <v-stepper-content step="2">
      <v-card class="mb-5">
        <v-layout row wrap>
          <v-layout v-for="web in ecommerce" :key="web.name">
            <v-flex pa-2 ma-2>
              <a :href="web.link" target="_blank">{{ web.name }}</a>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card>
    </v-stepper-content>

    <v-stepper-step editable step="3">Software</v-stepper-step>
    <small>Help Pages about softwares </small>
    <v-stepper-content step="3">
      <v-card class="mb-5">
        <v-layout row wrap>
          <v-layout v-for="web in softwares" :key="web.name">
            <v-flex pa-2 ma-2>
              <a :href="web.link" target="_blank">{{ web.name }}</a>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card>
    </v-stepper-content>

    <v-stepper-step editable step="4">Services</v-stepper-step>
    <small>Help Pages about our services</small>
    <v-stepper-content step="4">
      <v-card class="mb-5">
        <v-layout row wrap>
          <v-layout v-for="web in services" :key="web.name">
            <v-flex pa-2 ma-2>
              <a :href="web.link" target="_blank">{{ web.name }}</a>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card>
    </v-stepper-content>

    <v-stepper-step editable step="5">Miscellaneous</v-stepper-step>
    <small>Help Pages about miscellaneous things</small>
    <v-stepper-content step="4">
      <v-card class="mb-5">
        <v-layout row wrap>
          <v-layout v-for="web in miscellaneous" :key="web.name">
            <v-flex pa-2 ma-2>
              <a :href="web.link" target="_blank">{{ web.name }}</a>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card>
    </v-stepper-content>
  </v-stepper>
</template>

<script>
export default {
  name: "Help",
  data() {
    return {
      e6: 1,
      websites: [
        { name: "Wordpress", link: "https://blog.saascadetech.com/wordpress" },
        { name: "Bootstrap", link: "https://blog.saascadetech.com/bootstrap" },
        { name: "VueJs", link: "https://blog.saascadetech.com/vuejs" },
        {
          name: "Static Websites",
          link: "https://blog.saascadetech.com/static-website/"
        },
        {
          name: "Content Management System",
          link: "https://blog.saascadetech.com/content-management-system/"
        },
        {
          name: "Custom Websites",
          link: "https://blog.saascadetech.com/custom-website/"
        }
      ],
      ecommerce: [
        {
          name: "Prestashop",
          link: "https://blog.saascadetech.com/prestashop/"
        },
        { name: "OpenCart", link: "https://blog.saascadetech.com/opencart" },
        {
          name: "Woocommerce",
          link: "https://blog.saascadetech.com/woocommerce"
        }
      ],
      softwares: [],
      services: [
        {
          name: "Shared Web Hosting",
          link: "https://blog.saascadetech.com/shared-web-hosting/"
        },
        {
          name: "Premium hosting",
          link: "https://blog.saascadetech.com/premium-hosting/"
        },
        {
          name: "Firebase Hosting",
          link: "https://blog.saascadetech.com/firebase-hosting/"
        }
      ],
      miscellaneous: []
    };
  }
};
</script>
